<template>
  <div
    class="tbale_dig"
    :style="{
      left: left,
      top: top,
      height: height,
      width: width,
    }"
    id="tbale_dig"
  >
    <div class="icon_cont">
      <i @click="closeDialog" class="close_cont el-icon-close"></i>
    </div>
    <div class="table_title">{{ title }}</div>
    <div class="table_cont">
      <el-table
        v-loading="loading"
        :data="tableData"
        :height="305"
        stripe
        style="width: 100%"
        :header-cell-style="{
          background: '#2B4A6F',
          color: '#ffffff',
        }"
        :row-style="{ cursor: 'pointer' }"
        class="unglobal-sty"
      >
        <el-table-column align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          align="center"
          show-overflow-tooltip
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="tab_pog">
      <el-pagination
        class="unglobal-sty"
        background
        layout="prev, pager, next"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page.sync="page.pageNo"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import CockpitService from '../service/index'

export default {
  components: {},
  props: {
    left: {
      type: String,
      default: () => {
        return 'calc(100% + 30px)'
      },
    },
    top: {
      type: String,
      default: () => {
        return '80px'
      },
    },
    height: {
      type: String,
      default: () => {
        return '455px'
      },
    },
    width: {
      type: String,
      default: () => {
        return '785px'
      },
    },
    type: {
      type: Number,
      default: 0,
    },
    personType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      title: '人员在厂统计',
      keyword: '',
      tableData: [],
      tableColumnList: [
        {
          prop: 'personName',
          label: '姓名',
          width: '80',
        },
        {
          prop: 'personType',
          label: '人员类型',
          width: '100',
        },
        {
          prop: 'contractorName',
          label: '单位',
          width: '200',
        },
        {
          prop: 'deviceName',
          label: '设备名称',
          width: '160',
        },
        {
          prop: 'time',
          label: '入厂时间',
          width: '140',
        },
      ],
      page: {
        total: 0,
        pageNo: 1,
        pageSize: 15,
      },
      dialogVisible: false,
      detailVisible: false,
      personDetailId: '',
      titleList: [
        {
          lable: '环境报警',
        },
        {
          lable: '深基坑',
        },
        {
          lable: '塔吊检测',
        },
        {
          lable: '高支模',
        },
      ],
      activeIndex: 0,
      messageDialog: false,
      loading: false,
    }
  },
  watch: {
    type() {
      this.page.pageNo = 1
      this.getPersonnelDetail()
    },
    personType() {
      this.page.pageNo = 1
      this.getPersonnelDetail()
    },
  },
  created() {
    this.getPersonnelDetail()
  },
  methods: {
    handleCurrentChange(val) {
      this.page.pageNo = val
      this.getPersonnelDetail()
    },
    async getPersonnelDetail() {
      const [err, res] = await CockpitService.getParticipatePersonRecords({
        statisticsType: this.type,
        personType: this.personType,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
      })
      if (res && res.code == 0) {
        this.tableData = res.data.items
        this.page.total = res.data.totalCount
      }
      this.loading = false
    },
    closeDialog() {
      this.page.pageNo = 1
      this.dialogVisible = false
      this.activeIndex = 0
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/css/index.scss';
#tbale_dig {
  background-image: var(--dialogBgImg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
  position: absolute;
  z-index: 101;
  .icon_cont {
    text-align: right;
    margin: 20px 20px 0 0;
    position: relative;
    height: 20px;
    .el-button {
      padding: 5px !important;
      background: #3fbaff4c !important;
      color: #fff;
    }
    .close_cont {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      border-radius: 2px;
      background: rgba(63, 186, 255, 0.2980392157) !important;
      color: #fff;
      cursor: pointer;
      border: 1px solid #d9d9d9;
    }
  }
  .table_title {
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    text-align: center;
  }
  .search-box {
    display: flex;
    align-items: center;
    padding: 0px 0px 0px 20px;
    .el-form-item--mini.el-form-item {
      margin-bottom: 0px;
    }
    .el-input {
      width: 200px;
      // color: white !important;
    }
  }
  .topTitle {
    width: 100%;
    padding: 0 20px;
    display: flex;
    align-content: center;
    justify-content: start;
    margin-top: 13px;
    .title_item {
      width: 138px;
      height: 38px;
      text-align: center;
      line-height: 32px;
      padding: 2px;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.7);
      border: 0.858px solid rgba(255, 255, 255, 0.12);
      border-radius: 2px;
      cursor: pointer;
      .item_span {
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.12);
        border-radius: 2px;
      }
    }
    & > .title_item:nth-of-type(2) {
      margin: 0 20px;
    }
    & > .title_item:nth-of-type(3) {
      margin-right: 20px;
    }
    .active {
      position: relative;
      // background-image: url("../assets/homeImg/img_title.png") !important;
      background-repeat: no-repeat !important;
      background-size: 100% 100% !important;
      background-position: center 0 !important;
      color: #fff !important;
      font-size: 16px;
      font-weight: bold !important;
    }
    .active::before {
      content: '';
      display: inline-block;
      position: absolute;
      top: 6px;
      left: 2px;
      width: 1px;
      height: 20px;
      background-color: #fff;
    }
    .active::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 6px;
      right: 2px;
      width: 1px;
      height: 20px;
      background-color: #fff;
    }
  }
  .table_cont {
    padding: 20px 20px 5px 20px;
    .tableBtn {
      color: rgba(117, 199, 255, 1);
    }
  }
  .tab_pog {
    text-align: center !important;
  }
  .message_tips {
    width: 541px;
    height: 205px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center 0;
    position: absolute;
    left: 80px;
    top: 510px;
    color: #fff;
    .message_top {
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 24px;
      padding-left: 73px;
      margin-bottom: 8px;
    }
    .message_warnning {
      width: 100%;
      height: 147px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .message {
        display: flex;
        font-size: 24px;
        line-height: 34px;
        color: #eee;
        .icon {
          width: 31px;
          height: 31px;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .button {
        display: flex;
        margin-top: 24px;
        .confirm_btn {
          width: 80px;
          height: 36px;
          border: 1px solid #5479a3;
          border-radius: 4px;
          text-align: center;
          line-height: 36px;
          color: #7cade4;
          font-size: 14px;
        }
      }
    }
  }
  ::v-deep .el-input .el-input__inner {
    width: 200px;
    color: white !important;
    background-color: transparent !important;
  }

  ::v-deep .el-table__body-wrapper {
    height: calc(100% - 30px) !important;
  }
  // ::v-deep .el-form-item {
  //   width: auto !important;
  // }
  ::v-deep {
    .el-table__row .cell.el-tooltip {
      min-height: 10px;
      text-align: center;
    }
  }
}
::v-deep .el-table {
  th.gutter,
  colgroup.gutter {
    width: 5px !important;
  }
}
::v-deep .el-table__header colgroup col[name='gutter'] {
  display: table-cell !important;
}
.truncate {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  width: 100%;
}
</style>
